import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class TermoCondicaoService {

  constructor(private http: HttpService, private httpService: HttpService) { }
 
  generatebase64(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/enterprise/onlineTermsAndConditionsCerc', data, successHandle, errorHandle);

  }

  salveAceiteTermo(data: any, successHandle: Function, errorHandle: Function) {

    return this.http.doPost('/enterprise/onlineRegisterTermAndCondition', data, successHandle, errorHandle);

  }
   
}

